import type { ProcessStep } from '../types/content'

export const processSteps: ProcessStep[] = [
  {
    id: 'consulta',
    step: '01',
    title: 'Consulta inicial',
    description:
      'Conocemos tu negocio, tus servicios, tu mercado y el objetivo principal de tu página.',
  },
  {
    id: 'estrategia',
    step: '02',
    title: 'Estrategia y contenido',
    description:
      'Definimos la estructura, los textos persuasivos, llamadas a la acción y elementos que ayudarán a convertir visitantes en clientes.',
  },
  {
    id: 'diseno',
    step: '03',
    title: 'Diseño y conexión',
    description:
      'Creamos la página, conectamos formularios, WhatsApp, redes sociales, mensajes de texto o herramientas necesarias.',
  },
  {
    id: 'entrega',
    step: '04',
    title: 'Entrega y lanzamiento',
    description:
      'Revisamos contigo la página final y la dejamos lista para compartir con tus clientes o usar en campañas.',
  },
]
